module.exports = __webpack_public_path__ + "img/memorable-moments.30259c5a.png";